import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../../utils/analytics';

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    analytics.recordPageView();
  }, [location]);

  return null;
};

export default PageViewTracker;
